import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { CalendarDaysIcon } from '@heroicons/react/24/outline';
const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
};

const VisionSavedAdvice = ({ visionId }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!visionId) return;
    setLoading(true);
    try {
      const res = await axios.get('/api/advice/saved', { params: { vision_id: visionId } });
      setItems(res.data?.saved_items || []);
    } catch {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [visionId]);

  useEffect(() => {
    load();
  }, [load]);

  const exportIcs = async (savedId) => {
    const res = await axios.get(`/api/advice/saved/${savedId}/export.ics`, {
      responseType: 'blob',
    });
    downloadBlob(res.data, `aura-action-${savedId.slice(0, 8)}.ics`);
  };

  if (loading) {
    return <p className="text-body text-ink-muted py-8 text-center">Loading saved advice…</p>;
  }

  if (items.length === 0) {
    return (
      <div className="py-12 text-center">
        <p className="text-body text-ink-muted mb-2">No saved advice for this Vision yet.</p>
        <p className="text-label text-ink-faint">
          Use Save on any Aura recommendation in this Vision to build your list.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {items.map((item) => {
        const p = item.advice_payload || {};
        const savedAt = item.saved_at
          ? new Date(item.saved_at).toLocaleString()
          : '';
        return (
          <article
            key={item.saved_id}
            className="rounded-lg border border-hairline bg-bone p-5"
          >
            <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
              <div>
                <p className="text-label text-ink-faint">{savedAt}</p>
                <p className="font-display text-h3 text-ink mt-1">{p.verdict}</p>
                {p.number && (
                  <p className="text-body text-ink-muted mt-1 figure">{p.number}</p>
                )}
              </div>
              <button
                type="button"
                onClick={() => exportIcs(item.saved_id)}
                className="btn-secondary inline-flex items-center gap-1.5 text-label"
              >
                <CalendarDaysIcon className="w-4 h-4" />
                Add to calendar
              </button>
            </div>
            {p.next_step_24h && (
              <p className="text-body text-pine border-t border-hairline pt-3 mt-3">
                <span className="text-label text-ink-muted block mb-1">24-hour action</span>
                {p.next_step_24h}
              </p>
            )}
          </article>
        );
      })}
    </div>
  );
};

export default VisionSavedAdvice;
